import { useLayoutEffect, useState } from 'react'

export const useMeasuredHeight = () => {
  const [element, setElement] = useState<HTMLElement | null>(null)
  const [height, setHeight] = useState(0)

  useLayoutEffect(() => {
    if (!element) return undefined
    // Not entry.borderBoxSize: Safari < 15.4 omits it and older Firefox exposes it as a single object.
    const measure = () => setHeight(Math.ceil(element.getBoundingClientRect().height))
    measure()
    if (typeof ResizeObserver === 'undefined') return undefined
    const observer = new ResizeObserver(measure)
    observer.observe(element)
    return () => observer.disconnect()
  }, [element])

  return [setElement, height] as const
}
